import { registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import ptPT from '@angular/common/locales/pt-PT'
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, inject, Injector, LOCALE_ID, NgModule, NO_ERRORS_SCHEMA, provideAppInitializer } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideTransloco, TranslocoConfig, TranslocoModule } from '@ngneat/transloco'
import Lara from '@primeng/themes/lara'
import { AdblockModalComponent } from '@shared/adblock-modal/adblock-modal.component'
import { AppInitService, customMissingHandler, NotifyService, PipesModule, TokenInterceptor, translocoLoader, YesErrorHandler } from '@y4w-core'
import { providePrimeNG } from 'primeng/config'
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { env } from '../environments/environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'

export function init(appInitService: AppInitService, injector: Injector) {
  window['ctorinje'] = injector // makes the Angular Injector accessible anywhere
  return () => appInitService.init()
}

registerLocaleData(ptPT)

@NgModule({
  declarations: [
    AppComponent,
    AdblockModalComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    PipesModule], providers: [
      AppInitService,
      DialogService,
      DynamicDialogRef,
      DynamicDialogConfig,
      provideAnimationsAsync(),
      providePrimeNG({
        theme: {
          preset: Lara,
          options: {
            darkModeSelector: false,
            cssLayer: {
              name: "primeng",
              order: "base, primeng, components"
            }
          }
        }
      }),
      provideAppInitializer(() => {
        const initializerFn = (init)(inject(AppInitService), inject(Injector))
        return initializerFn()
      }),
      env.production && !localStorage.getItem('debug') ? { provide: ErrorHandler, useClass: YesErrorHandler } : ErrorHandler,
      { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
      { provide: LOCALE_ID, useValue: 'pt-PT' },
      provideTransloco({
        config: {
          missingHandler: {
            logMissingKey: false
          },
          availableLangs: ['pt-PT'], // availableLangs.map(lang => lang.name),
          defaultLang: 'pt-PT', // defaultLang,
          fallbackLang: `pt-PT`,
          prodMode: env.production,
          reRenderOnLangChange: true
        } as TranslocoConfig
      }),
      translocoLoader,
      customMissingHandler,
      provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule {
  constructor(dialog: DialogService, notify: NotifyService, injector: Injector) {
    window['ctorinje'] = injector // makes the Angular Injector accessible anywhere
    notify.defineDialogService(dialog)
  }
}
